import styled from 'styled-components';

export const HeadingButtonContainer = styled.div`
  display: flex;
  justify-content: end;
`;

export const DropDownListContainer = styled.div`
  position: absolute;
  z-index: 100;
  width: 146px;
  margin-top: 10px;
  margin-left: -16px;
`;

export const DropDownList = styled.ul`
  padding: 0px !important;
  margin: 0;
  padding-left: 1em;
  background: #ffffff;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: #3faffa;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  &:first-child {
    padding-top: 0.8em;
  }
`;

export const ListItem = styled.li`
  list-style: none;
  cursor: pointer;
  color: #285c87;
  padding-left: 15px;
  line-height: 28px;
  &:hover {
    background-color: #f8f9fa;
  }
`;
